// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__TGpwn","inputContainer":"Form_inputContainer__LFfEz","buttonWrapper":"Form_buttonWrapper__+tkJ7","SubmitButton":"Form_SubmitButton__wuSD0"};